var style = {"z-form-message":"z-form-message","z-form-message--error":"z-form-message--error","z-form-message__text":"z-form-message__text","z-form-message__icon-wrap":"z-form-message__icon-wrap","z-form-message__icon":"z-form-message__icon","z-form-message__icon--error":"z-form-message__icon--error","z-form-message__icon--info":"z-form-message__icon--info"};

export { style as default };
//# sourceMappingURL=FormMessage.module.scss.js.map
